const JSON_API_URL = '/wp-json/exp1';

export const fetchWpJson = (endpoint, options, apiVersion = 1) => {
  return fetch(`${JSON_API_URL}/v${apiVersion}${endpoint}`, options);
}
